import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const AnalyticsIcon = ({
  width = 20,
  height = 20,
  color = '#38383E',
  ...props
}: IconProps) => (
  <SvgComponent viewBox='0 0 20 20'
    width={width}
    height={height}
    {...props}
  >
    <path
      fill={color}
      d='M3.333 2.5a.833.833 0 0 0-.833.833v13.334a.833.833 0 0 0 .833.833h13.334a.833.833 0 0 0 .833-.833V3.333a.833.833 0 0 0-.833-.833H3.333ZM1.667 3.333A1.667 1.667 0 0 1 3.333 1.667h13.334A1.667 1.667 0 0 1 18.333 3.333v13.334a1.667 1.667 0 0 1-1.666 1.666H3.333a1.667 1.667 0 0 1-1.666-1.666V3.333Z'
    />
    <path
      fill={color}
      d='M14.167 6.667a.833.833 0 0 1 .833.833v6.667a.833.833 0 1 1-1.667 0V7.5a.833.833 0 0 1 .834-.833ZM10 9.167a.833.833 0 0 1 .833.833v4.167a.833.833 0 1 1-1.666 0V10A.833.833 0 0 1 10 9.167ZM5.833 11.667a.833.833 0 0 1 .834.833v1.667a.833.833 0 1 1-1.667 0V12.5a.833.833 0 0 1 .833-.833Z'
    />
  </SvgComponent>
);

export default AnalyticsIcon;
